import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SelectBox } from "@/components/common/ui";

export async function moveLead(lead, stage, extra = {}) {
  const { data } = await api.post(`/leads/${lead.id}/stage`, { stage_id: stage.id, ...extra });
  return data;
}

export default function StageMoveDialog({ move, onClose, onMoved }) {
  const { meta } = useAuth();
  const [wonValue, setWonValue] = useState("");
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const { lead, stage } = move || {};

  useEffect(() => {
    if (move) {
      setWonValue(move.lead.value || "");
      setReason("");
      setNote("");
    }
  }, [move]);

  const submit = async () => {
    try {
      const extra = { note };
      if (stage.type === "won") extra.won_value = Number(wonValue) || 0;
      if (stage.type === "lost") extra.lost_reason = reason;
      const data = await moveLead(lead, stage, extra);
      toast.success(`Moved to ${stage.name}`);
      onMoved?.(data);
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={!!move} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="stage-move-dialog">
        {move && (
          <>
            <DialogHeader><DialogTitle>Move “{lead.name}” to {stage.name}</DialogTitle></DialogHeader>
            {stage.type === "won" && (
              <div className="space-y-1.5"><Label>Actual won value (PHP)</Label><Input type="number" min="0" value={wonValue} onChange={(e) => setWonValue(e.target.value)} data-testid="won-value-input" /></div>
            )}
            {stage.type === "lost" && (
              <div className="space-y-1.5"><Label>Reason for loss *</Label>
                <SelectBox value={reason} onChange={setReason} testid="lost-reason-select" className="w-full" allLabel="Select a reason" options={(meta.settings.lost_reasons || []).map((r) => ({ value: r, label: r }))} />
              </div>
            )}
            <div className="space-y-1.5"><Label>Note (optional)</Label><Textarea value={note} onChange={(e) => setNote(e.target.value)} data-testid="stage-note-input" /></div>
            <DialogFooter>
              <Button variant="outline" onClick={onClose}>Cancel</Button>
              <Button onClick={submit} disabled={stage.type === "lost" && !reason} className={stage.type === "won" ? "bg-emerald-600 hover:bg-emerald-700" : stage.type === "lost" ? "bg-red-600 hover:bg-red-700" : "bg-orange-500 hover:bg-orange-600"} data-testid="stage-move-confirm">Confirm move</Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
